// extracted by mini-css-extract-plugin
export var content = "table-module--content--24168";
export var contentDesktop = "table-module--contentDesktop--46f45";
export var contentMobile = "table-module--contentMobile--03b11";
export var item = "table-module--item--3383b";
export var itemHeader = "table-module--itemHeader--3d6ad";
export var number = "table-module--number--cc2a9";
export var section = "table-module--section--f2b58";
export var text = "table-module--text--4e521";
export var title = "table-module--title--28701";
export var wrapperInfo = "table-module--wrapperInfo--4bf88";